import type * as React from "react"

import { cn } from "@/lib/utils"

interface EmptyProps extends Omit<React.ComponentProps<"div">, "title"> {
  icon?: React.ReactNode
  title: string
  description?: string
}

export function Empty({
  icon,
  title,
  description,
  children,
  className,
  ...props
}: EmptyProps) {
  return (
    <div
      data-slot="empty"
      className={cn(
        "flex flex-col items-center justify-center gap-4 py-10 text-center",
        className,
      )}
      {...props}
    >
      {icon && (
        <div className="bg-muted text-muted-foreground flex items-center justify-center rounded-xl p-3">
          {icon}
        </div>
      )}
      <div className="flex max-w-sm flex-col gap-1">
        <p className="text-sm font-medium">{title}</p>
        {description && (
          <p className="text-muted-foreground text-sm">{description}</p>
        )}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  )
}
